import { Graphics, Text, TextStyle } from "pixi.js";
import { HelperFunctions } from "../../tsthree";
import { tsthreeConfig } from "../../config/tsthreeConfig";
import isMobile from "is-mobile";

const textLines: Array<{
    str: string;
    align: "center" | "left" | "right";
}> = [
    {
        str: "A fatal error has occurred. To continue:",
        align: "center"
    },
    {
        str: "\n*  " + (isMobile() ? "Tap the screen" : "Press Enter") + " to return to DoctOS, or",
        align: "left"
    },
    {
        str: "*  " + (isMobile() ? "Refresh the page" : "Press CTRL+DEL") + " to restart DoctOS.",
        align: "left"
    },
    {
        str: "\nYou will not lose any progress.",
        align: "left"
    }
];

export function ShowBluescreen(err?: string, _trulyFatal?: boolean) {
    const graphics = new Graphics();
    graphics.beginFill(0x0000ff);
    graphics.drawRect(0, 0, 64, 64);
    graphics.endFill();
    HelperFunctions.smartScale2D(
        {
            x: tsthreeConfig.width,
            y: tsthreeConfig.height
        },
        graphics
    );
    graphics.zIndex = Number.MAX_SAFE_INTEGER - 5;
    ENGINE.getStage().addChild(graphics);

    const textObjs: Array<Text> = [];
    let runningHeight = 0;
    textLines.forEach((t, i) => {
        const text = new Text((_trulyFatal && i === 1) ? "" : t.str, new TextStyle({
            fill: 0xffffff,
            fontFamily: "Courier New",
            fontSize: 22,
            fontWeight: "bold",
            wordWrap: true,
            wordWrapWidth: tsthreeConfig.width,
            align: t.align,
        }));
        // text.scale.set(1.0, 1.0);
        text.anchor.set(0, 0);
        text.zIndex = Number.MAX_SAFE_INTEGER;

        switch(t.align) {
            case "center":
                text.position.set(
                    (tsthreeConfig.width * 0.5) + (text.width * -0.5),
                    (tsthreeConfig.height * 0.325) + runningHeight,
                );
                break;
            case "left":
                text.position.set(
                    textObjs[textObjs.length - 1]?.x || (tsthreeConfig.width * 0.5),
                    (tsthreeConfig.height * 0.325) + runningHeight,
                );
                break;
            case "right":
                console.error("not implemented");
                // text.position.set(
                //     (tsthreeConfig.width * 0.5) + (text.width * -0.5),
                //     (tsthreeConfig.height * 0.325) + runningHeight,
                // );
                break;
        }
        runningHeight += (text.height || 22);
        ENGINE.getStage().addChild(text);
        textObjs.push(text);
    });

    ENGINE.getStage().sortableChildren = true;
    ENGINE.getStage().sortChildren();
    ENGINE.getStage().sortableChildren = false;

    if(err) {
        const x = textObjs[textObjs.length - 1]?.x || (tsthreeConfig.width * 0.5);
        const text = new Text("\n\nError: " + err, new TextStyle({
            fill: 0xffffff,
            fontFamily: "Courier New",
            fontSize: 22,
            fontWeight: "bold",
            wordWrap: true,
            wordWrapWidth: tsthreeConfig.width - x,
            align: "left",
        }));
        text.position.set(
            x,
            (tsthreeConfig.height * 0.325) + runningHeight,
        );
        ENGINE.getStage().addChild(text);
        textObjs.push(text);
    }

    function onEnterPressed(ev: KeyboardEvent) {
        if(ev.key == "Enter" && !_trulyFatal) {
            document.removeEventListener("keydown", onEnterPressed);
            textObjs.forEach((e) => e.parent.removeChild(e));
            graphics.parent.removeChild(graphics);
            graphics.destroy();
        } else if(
            ev.key === "Delete" &&
            ev.ctrlKey
        ) {
            location.reload();
        }
    }
    function onPointerPressed() {
        document.removeEventListener("pointerup", onPointerPressed);
        textObjs.forEach((e) => e.parent.removeChild(e));
        graphics.parent.removeChild(graphics);
        graphics.destroy();
    }

    if(isMobile()) {
        document.body.addEventListener("pointerup", onPointerPressed);
    } else {
        document.addEventListener("keydown", onEnterPressed);
    }
}